/**
 * Okendo Recommendation Rate Extractor
 * Extracts recommendation percentage from Okendo ReviewsWidgetSnippet
 */

class OkendoRecommendationExtractor {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.extractRecommendations());
    } else {
      this.extractRecommendations();
    }

    this.observeDynamicContent();
  }

  extractRecommendations() {
    const hiddenWidgets = document.querySelectorAll('.okendo-widget-hidden');
    
    hiddenWidgets.forEach(widget => {
      const productId = widget.getAttribute('data-product-id');
      if (!productId) return;

      const displayElement = document.querySelector(
        `.okendo-recommend-rate[data-product-id="${productId}"]`
      );
      
      if (!displayElement) return;

      const recommendText = widget.textContent || widget.innerText;
      const match = recommendText.match(/(\d+)%\s*would recommend/i);
      
      if (match && match[1]) {
        displayElement.textContent = match[1];
        return;
      }

      setTimeout(() => {
        const okendoElement = widget.querySelector('[data-oke-reviews-product-listing-aggregate-rating]');
        if (okendoElement) {
          const recommendText = okendoElement.textContent || okendoElement.innerText;
          const match = recommendText.match(/(\d+)%\s*would recommend/i);
          if (match && match[1]) {
            displayElement.textContent = match[1];
            return;
          }
        }

        const allElements = widget.querySelectorAll('*');
        for (let element of allElements) {
          const text = element.textContent || element.innerText;
          if (text.includes('would recommend')) {
            const match = text.match(/(\d+)%/);
            if (match && match[1]) {
              displayElement.textContent = match[1];
              return;
            }
          }
        }

        console.warn(`Could not extract recommendation rate for product ${productId}, using default 100%`);
        displayElement.textContent = '100';
      }, 500);
    });
  }

  observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      let shouldExtract = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (
            node.classList?.contains('okendo-widget-hidden') ||
            node.querySelector?.('.okendo-widget-hidden')
          )) {
            shouldExtract = true;
          }
        });
      });
      
      if (shouldExtract) {
        setTimeout(() => this.extractRecommendations(), 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

new OkendoRecommendationExtractor();

